export default "__VITE_ASSET__GolQ$1OJ__"